import classNames from 'classnames/bind';
import { i18nKeys, useTranslation } from 'locales';

import styleIdentifiers from './RecoveryPlan.module.scss';

const styles = classNames.bind(styleIdentifiers);

export const RecoveryPlanStepAICallLine = () => {
  const { t } = useTranslation();

  return (
    <div className={styles('step-template')}>
      <div className={styles('template')}>
        <div className={styles('template-name')}>{t(i18nKeys.AI_CALL)}</div>
      </div>
    </div>
  );
};
